import { render, staticRenderFns } from "./DeletePersonalDataModal.vue?vue&type=template&id=1e1d2125"
import script from "./DeletePersonalDataModal.vue?vue&type=script&lang=ts"
export * from "./DeletePersonalDataModal.vue?vue&type=script&lang=ts"
import style0 from "./DeletePersonalDataModal.vue?vue&type=style&index=0&id=1e1d2125&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports